export const FETCH_DATA = "fetch-data"
export const LOGIN = "LOGIN";